import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Drawer, Fab, Divider, IconButton, FormControl, FormLabel, Button, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import { ChevronRight, FilterList } from '@material-ui/icons';

const drawerWidth = 240;

const styles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerHeader: {
    display: 'block',
  },
  openDrawerFab: {
    position: 'absolute',
    top: 10,
    right: 10,
    zIndex: 1000,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  toolbar: theme.mixins.toolbar,
  formControl: {
    margin: theme.spacing(3),
  },
  group: {
    margin: `${theme.spacing(1)}px 0`,
  },
  filterButton: {
    marginTop: theme.spacing(1),
    minWidth: 160,
  },
}));

const initialState = {
  open: false,
};

function FilterDrawer(props) {
  const [state, setState] = useState(initialState);
  const classes = styles();

  const handleDrawerOpen = () => {
    setState({
      ...state,
      open: true,
    });
  };

  const handleDrawerClose = () => {
    setState({
      open: false,
    });
  };

  const getAssignees = (values = []) => {
    return ['none', ...values];
  };

  const {
    assignees,
    eventNameFilterValue,
    handleEventNameFilterChange,
    handleAssigneeFilterChange,
    assigneeFilterSubmit,
    inventoryTags,
    handleInventoryFilterChange,
    handleInventoryTagsFilterChange,
  } = props;
  const { open } = state;

  return (
    <React.Fragment>
      <Fab
        color="primary"
        aria-label="Filter"
        onClick={handleDrawerOpen}
        style={{ position: 'absolute', top: 10, right: 10, zIndex: 1000 }}
        className={classes.openDrawerFab}
      >
        <FilterList />
      </Fab>
      <Drawer
        variant="persistent"
        anchor="right"
        open={open}
        className={classes.drawer}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerHeader}>
          <IconButton onClick={handleDrawerClose}>
            <ChevronRight />
          </IconButton>
        </div>
        <Divider />
        <form className={classes.container} noValidate autoComplete="off">
          <div>
            <FormControl component="fieldset" className={classes.formControl}>
              <FormLabel component="legend">Filter by</FormLabel>
              <div className={classes.root}>
                <TextField
                  variant="standard"
                  label="Event Name"
                  placeholder="Event Name"
                  value={eventNameFilterValue}
                  onChange={handleEventNameFilterChange}
                />
              </div>
              <div className={classes.root}>
                <Autocomplete
                  multiple
                  id="tags-standard"
                  options={getAssignees(assignees)}
                  getOptionLabel={option => option}
                  onChange={handleAssigneeFilterChange}
                  renderInput={params => (
                    <TextField {...params} variant="standard" label="Assignee" placeholder="Assignee" />
                  )}
                />
              </div>
              <div className={classes.root}>
                <Autocomplete
                  // multiple
                  defaultValue="all"
                  id="tags-standard"
                  options={['new', 'all']}
                  getOptionLabel={option => option}
                  onChange={handleInventoryFilterChange}
                  renderInput={params => (
                    <TextField {...params} variant="standard" label="Inventory" placeholder="Inventory" />
                  )}
                />
              </div>
              <div className={classes.root}>
                <Autocomplete
                  multiple
                  id="tags-standard"
                  options={inventoryTags}
                  getOptionLabel={option => option}
                  onChange={handleInventoryTagsFilterChange}
                  renderInput={params => <TextField {...params} variant="standard" label="Tags" placeholder="Tags" />}
                />
              </div>
              <div>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.filterButton}
                  onClick={assigneeFilterSubmit}
                  fullWidth
                >
                  Search
                </Button>
              </div>
            </FormControl>
          </div>
        </form>
      </Drawer>
    </React.Fragment>
  );
}

FilterDrawer.propTypes = {
  eventNameFilterValue: PropTypes.string.isRequired,
  assigneeRadioValue: PropTypes.string.isRequired,
  assignees: PropTypes.array.isRequired,
  handleAssigneeFilterChange: PropTypes.func.isRequired,
  assigneeFilterSubmit: PropTypes.func.isRequired,
  assigneeFilterValue: PropTypes.string.isRequired,
  handleEventNameFilterChange: PropTypes.func.isRequired,
  handleInventoryFilterChange: PropTypes.func.isRequired,
  handleAssigneeRadioChange: PropTypes.func.isRequired,
  userEmail: PropTypes.string.isRequired,
  tags: PropTypes.array.isRequired,
  inventoryTags: PropTypes.array.isRequired,
  handleInventoryTagsFilterChange: PropTypes.array.isRequired,
};

export default FilterDrawer;
